import React from "react";
import { parsal_img } from "../../../assets/mediaCall";
const GlobalService = () => {
  return (
    <div
      className="bg-white py-20 px-10 smp:px-4 flex flex-col items-center inter"
      style={{
        background: "linear-gradient(180deg, #FFFFFF 0%, #F7FAFF 100%)",
      }}
    >
      <h4 className="text-[30px] sm:text-2xl font-semibold sm:font-bold mb-6">
        Serve Globally
      </h4>
      {/* Stats Section */}
      <div className="bg-gray-100 rounded-lg py-6 px-6 smp:px-3 xs:px-2 flex justify-around w-full max-w-3xl mb-10">
        <div className="flex flex-col items-center">
          <span className="text-[25.78px] sm:text-[18px] xs:text-[16px] inter">
            20+
          </span>
          <span className="text-[15.47px] text-[#9294B6] smp:text-[14px] xs:text-[12px]">
            Cities
          </span>
        </div>
        <div className="flex flex-col items-center">
          <span className="text-[25.78px] sm:text-[18px] xs:text-[16px] inter">
            5 Lakh+
          </span>
          <span className="text-[15.47px] text-[#9294B6] smp:text-[14px] xs:text-[12px]">
            Driving Partners
          </span>
        </div>
        <div className="flex flex-col items-center">
          <span className="text-[25.78px] sm:text-[18px] xs:text-[16px] inter">
            1 Crore+
          </span>
          <span className="text-[15.47px] text-[#9294B6] smp:text-[14px] xs:text-[12px]">
            Customers
          </span>
        </div>
        <div className="flex flex-col items-center">
          <span className="text-[25.78px] sm:text-[18px] xs:text-[16px] inter">
            10 Crore+
          </span>
          <span className="text-[15.47px] text-[#9294B6] smp:text-[14px] xs:text-[12px]">
            Trips
          </span>
        </div>
      </div>

      <div className="relative">
        {/* Map image with relative positioning */}
        <div className="relative w-[90%] mx-auto">
          <img src={parsal_img.map} alt="Map" className="w-full h-auto" />
        </div>

        {/* Plot 1 image positioned absolutely at Lucknow */}
        <div className="absolute top-[30%] left-[50%] sm:top-[15%] smp:top-[10%] smp:left-[42%]">
          <img
            className="text-white max-h-[73.6px] max-w-[66.57px]"
            src={parsal_img.plot1}
            alt="Plot1"
          />
        </div>

        {/* Plot 2 image positioned absolutely at Delhi */}
        <div className="absolute top-[15%] left-[55%] sm:top-[8%] smp:top-0 smp:left-[47%]">
          <img
            className="text-white max-h-[73.6px] max-w-[66.57px]"
            src={parsal_img.plot2}
            alt="Plot2"
          />
        </div>
      </div>
    </div>
  );
};
export default GlobalService;
